import { render, staticRenderFns } from "./studentLabel.vue?vue&type=template&id=103d7f52&scoped=true&"
import script from "./studentLabel.vue?vue&type=script&lang=ts&"
export * from "./studentLabel.vue?vue&type=script&lang=ts&"
import style0 from "./studentLabel.vue?vue&type=style&index=0&id=103d7f52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103d7f52",
  null
  
)

export default component.exports